module.exports = __webpack_public_path__ + "images/icons/icon-lock-81769540.svg";